module.exports = __webpack_public_path__ + "static/img/zs.1784015206260.png";